import { Link } from "react-router-dom";
import { PHONE_NUMBER, PHONE_TEL } from "@/components/feature/navigation";

export default function CTA() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-500 via-primary-400 to-primary-300 px-6 py-16 md:px-16 md:py-20">
          <div className="absolute -top-10 -right-10 w-48 h-48 rounded-full bg-white/10"></div>
          <div className="absolute -bottom-16 -left-10 w-64 h-64 rounded-full bg-white/10"></div>

          <div className="relative z-10 flex flex-col items-center text-center gap-5">
            <span className="inline-flex items-center gap-2 text-white/90 text-sm font-medium">
              <i className="ri-sparkling-line"></i>
              첫 방문 고객을 위한 무료 피부 진단
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight">
              지금 비앙카에서
              <br />
              피부 힐링을 시작하세요
            </h2>
            <p className="text-white/90 text-sm md:text-base max-w-xl leading-relaxed">
              부담 없이 상담부터 시작해보세요. 피부 고민을 듣고,
              <br className="hidden sm:block" />
              고객님께 꼭 맞는 관리 방향을 안내해드립니다.
            </p>
            <div className="mt-4 flex flex-col sm:flex-row items-center gap-3">
              <Link
                to="/reservation"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-white text-primary-600 text-base font-semibold whitespace-nowrap transition-all hover:bg-background-50 cursor-pointer"
              >
                예약상담
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href={PHONE_TEL}
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border border-white/50 text-white text-base font-semibold whitespace-nowrap transition-all hover:bg-white/10 cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                {PHONE_NUMBER}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}